import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatService } from 'src/app/core/services/date-format.service';
import { DateKind } from 'src/app/core/services/date-format.util';

/**
 * Formats a date through the user's display preferences. `fallback` is the call
 * site's original Angular format (e.g. 'short', 'mediumDate'); it preserves today's
 * look while the user is on 'system', and tells the service the intended granularity.
 * Impure so it re-renders when the prefs change (including cross-tab updates).
 */
@Pipe({ name: 'appDate', standalone: true, pure: false })
export class AppDatePipe implements PipeTransform {
  constructor(private dateFormat: DateFormatService) {}

  transform(value: unknown, fallback = 'mediumDate', kind?: DateKind, locale?: string): string | null {
    return this.dateFormat.formatDate(value, fallback, kind, locale);
  }
}
